package org.matthewo.recharts.type

object LayoutDirection {

    val horizontal: LayoutDirection
        get() = "horizontal".unsafeCast<LayoutDirection>()

    val vertical: LayoutDirection
        get() = "vertical".unsafeCast<LayoutDirection>()
}
